import * as React from 'react';
import { Link } from '@material-ui/core';
import { useRecordContext } from 'react-admin';

const MyUrlField = ({ source }) => {
    const record = useRecordContext();
    const value = record && record[source];

    if (value == null) {
        return null;
    }

    return (
        <Link href={value}>
            Certificate Link
        </Link>
    );
};

MyUrlField.defaultProps = {
    addLabel: true,
};

export default MyUrlField;